<template>
  <div id="app">
    <router-view />
    <LoadingOverlay />
  </div>
</template>

<script setup>
import LoadingOverlay from '@/components/LoadingOverlay.vue';
</script>

<style>
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
